import { userSettings } from '@/globals/userSettings'

import adjustFontSize from '@/tools/adjustFontSize'
import renderTools from './renderTools'
import enableContrast from '@/tools/enableContrast'

export default function runAccessibility() {
  const fontSize = userSettings?.states?.fontSize ?? 1
  adjustFontSize(Number(fontSize.toFixed(2)))
  renderTools()
  enableContrast(userSettings?.states?.contrast)
}
